import request from "@/utils/request";

export const shopUpdate = async (data) =>
  request({ url: "/easyapp/shop/update", method: "put", data });
export const shopSave = async (data) =>
  request({ url: "/easyapp/shop/save", method: "post", data });
/**
 * 删除
 */
export const shopDel = async (data) =>
  request({ url: "/easyapp/shop", method: "DELETE", data });

//获取标签导航数据源
export const comDSList = async (params) =>
  request({ url: "/easyapp/config/comDSList", method: "get", params });

//根据规则标识获取数据源接口（新
export const getDatasourceList = async (params) =>
  request({
    url: "/easyapp/datasource/getDatasourceList",
    method: "get",
    params,
  });

// 根据规则id查询数据源
export const getDatasourceByDsId = (id) =>
  request({
    url: "/easyapp/datasource/" + id,
    method: "get",
  });

export const getDatasourceByUrl = (url) =>
  request({
    url: url,
    method: "get",
  });

//查询规则下的装饰器接口
//easyapp/decorator/getDecoratorListByRuleIds?ruleIds=courseList

export const getDecoratorListByRuleIds = async (params) =>
  request({
    url: "/easyapp/decorator/getDecoratorListByRuleIds",
    method: "get",
    params,
  });

export const datasourceMapperPage = async (params) =>
  request({ url: "/easyapp/dataMapper/page", method: "get", params });

export const datasourcePage = async (params) =>
  request({ url: "/easyapp/datasource/page", method: "get", params });

//筛选项 easyapp/tabOption/page

export const tabOptionPage = async (params) =>
  request({ url: "/easyapp/tabOption/page", method: "get", params });

export const getRuleList = async (data) =>
  request({ url: "/easyapp/rule/getListBy", method: "post", data });

export const getCategoryList = async (params) =>
  //console.log();
  request({ url: params.url, method: "get", params });

export const getCategoryListPost = async (data) =>
  request({ url: data.url, method: "post", data });

export const getProjectDetail = async (params) =>
  request({ url: "/easyapp/shop/" + params, method: "get" });

//组件分组

export const getTenantComponentGroupList = async (params) =>
  request({
    url: "/easyapp/componentGroup/getTenantComponentGroupList",
    method: "get",
    params,
  });

//装饰器样式
//分页查询装饰器样式
export const getDecoratorPage = async (params) =>
  request({ url: "/easyapp/decorator-style/page", method: "get", params });
//根据ID查询装饰器样式
export const getDecoratorView = async (params) =>
  request({ url: "/easyapp/decorator-style/" + params.id, method: "get" });
//新增装饰器样式
export const addDecorator = async (data) =>
  request({ url: "/easyapp/decorator-style", method: "post", data });
//修改装饰器样式
export const editDecorator = async (data) =>
  request({ url: "/easyapp/decorator-style", method: "put", data });
//删除装饰器样式
export const delDecorator = async (data) =>
  request({ url: "/easyapp/decorator-style", method: "DELETE", data });
//根据装饰器ID查询样式列表
export const getDecoratorList = async (params) =>
  request({ url: "/easyapp/decorator-style/list/" + params.id, method: "get" });
//设置默认样式
export const setDefaultDecorator = async (params) =>
  request({
    url: "/easyapp/decorator-style/set-default/" + params.id,
    method: "put",
  });
//导出
export const exportDecorator = async (params) =>
  request({ url: "/easyapp/decorator-style/export", method: "get" });
//查询自定义动画
export const loadingAnimationPage = async (params) =>
  request({ url: "/easyapp/loadingAnimation/page", method: "get", params });
//增加自定义动画
export const addLoadingAnimation = async (data) =>
  request({ url: "/easyapp/loadingAnimation/add", method: "post", data });
